import { createGlobalAlertStore } from '@/stores/createGlobalAlertStore';

export const useGlobalAlertStore = createGlobalAlertStore();
